import { Navbar, Nav, Container, NavDropdown, Button } from "react-bootstrap";

const DoulaNotesNavbar = () => {
    return (
        <Navbar expand="lg" style={{ backgroundColor: "#fff" }} sticky="top">
            <Container>
                {/* Logo */}
                <Navbar.Brand href="https://www.doulanotes.com">
                    <img
                        src="https://static.wixstatic.com/media/936cf0_85c410791041463fa46c6944b286ab64~mv2.png"
                        alt="DoulaNotes Logo"
                        style={{ height: "50px", objectFit: "contain", marginRight: "10px" }}
                    />
                    <img
                        src="https://static.wixstatic.com/media/936cf0_20576b16beb24534b9c031133c4ff263~mv2.png/v1/fill/w_334,h_142,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/HWCLI%20logo.png"
                        alt="DoulaNotes Logo"
                        style={{ height: "50px", objectFit: "contain" }}
                    />
                </Navbar.Brand>

                {/* Hamburger toggle */}
                <Navbar.Toggle aria-controls="basic-navbar-nav" />

                {/* Navbar links */}
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link href="https://www.doulanotes.com/about">About</Nav.Link>
                        <Nav.Link href="https://www.doulanotes.com/membership">Membership</Nav.Link>
                        <Nav.Link href="https://www.doulanotes.com/features">Features</Nav.Link>
                        <Nav.Link href="https://www.doulanotes.com/contact"> Contact </Nav.Link>
                        <Nav.Link> Directory </Nav.Link>
                        <NavDropdown title="News" id="news-dropdown">
                            <NavDropdown.Item href="https://www.doulanotes.com/newyork">New York</NavDropdown.Item>
                            <NavDropdown.Item href="https://www.doulanotes.com/hwcli">HWCLI</NavDropdown.Item>
                        </NavDropdown>
                    </Nav>

                    {/* Right buttons */}
                    <Nav>
                        <Nav.Link href="https://app.iasonotes.com/doula-registration">
                            <Button className="btn-doula-toggle-brand" size="sm">Register</Button>
                        </Nav.Link>
                        <Nav.Link href="https://app.iasonotes.com/login">
                            <Button className="ms-2 btn-doula-toggle-brand" size="sm">Sign In</Button>
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default DoulaNotesNavbar;
